import React from 'react';
import { LayoutInternal } from '@/layout';
import WhitePaper from '@/components/elevation/WhitePaper/WhitePaper';
import { TitleFeatured } from '@/components/typography';
import FilterListItems from '@/features/cruise/components/FilterListItems/FilterListItems';
import { urlCruise } from '@/utils/browser';

export interface RegionIndexProps {
  data: CruiseRegionDataType;
}

const RegionList = ({ data }: RegionIndexProps) => {
  const { page } = data;
  const breadcrumbs: BreadcrumbType = [
    { path: urlCruise(), text: 'Cruzeiros' },
    { path: urlCruise('regioes'), text: 'Regiões' },
    { path: page.slug, text: page.title },
  ];

  return (
    <LayoutInternal breadcrumbs={breadcrumbs} mediaCover={page.cover}>
      <WhitePaper col={12}>
        <TitleFeatured as="h1" title={`Cruzeiros ${page.title}`} description={page.description} />
      </WhitePaper>
      <WhitePaper col={12}>
        <FilterListItems initialData={page.cruise_itineraries || []} placeholder="Filtrar Itens" />
      </WhitePaper>
    </LayoutInternal>
  );
};

export default RegionList;
